import React from 'react';
import { Link } from 'react-router-dom';

const ExternalSourceInfo = ({ projectId, version }) => {
  return (
    <div className="row">
      <div className="col-12">
        <ul>
          <li>To access current logged in user's data use {`{{current_user.key}}`}</li>
          <li>To access data from browser session {`{{current_session.key}}`}</li>
          <li>To access data from browser session form data {`{{form_data_session.key}}`}</li>
          <li>
            To access data from environment based variables {`{{environment_variable.key}}`}&nbsp;
            <u>
              <Link to={`/2.0/app-setting/${version}/v/${projectId}`} style={{ color: '#1F2041' }}>
                Create Environment Variable{' '}
                <i className="webconnect webconnect-box-arrow-up-right"></i>
              </Link>
            </u>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ExternalSourceInfo;
